module.exports = __webpack_public_path__ + "media/images/home/concept_1_sp-837028e7adeb3a03eaf274ae6cc070b9.png";